import { get } from 'lodash';

export const getLocation = (state) => state.location;
export const getPrevPath = (state) => getLocation(state).prevPath;
export const getSectionUrl = (state) => getLocation(state).sectionUrl;
export const getBaseUrl = (state) => getLocation(state).baseUrl;
export const getUrl = (state) => getLocation(state).url;
export const getQuery = (state) => getLocation(state).query;
export const getIsQaMode = (state) => get(getQuery(state), 'isqa', false);
